import request from '@/utils/request'

export function login(data) { 
  return request({
    url: '/v1/login/oAuth2Check',
    method: 'get',
    params: data
  })
}

export function logout(data) {
  return request({
    url: '/bigmap/breeder/logout',
    method: 'get',
    params: data
  })
}

export function updatePwd(data) {
  return request({
    url: '/bigmap/breeder/password',
    method: 'put',
    params: data
  })
}

